(() => {
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
  const track = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`french_bites:${name}`, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `french_bites_${name}`, ...detail });
  };
  const parse = (root, selector, first) => {
    const node = root.querySelector(selector);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]').map((row, index) => ({
        position: first + index, french: row[0], antonym: row[1], english: row[2],
        antonymEnglish: row[3], category: row[4], headAudio: row[5], antonymAudio: row[6],
      }));
    } catch (error) {
      console.error('French antonym data could not be loaded.', error);
      return [];
    }
  };
  const initialize = (root) => {
    const data = [...parse(root, '[data-fan-free-data]', 1), ...parse(root, '[data-fan-member-data]', 101)];
    const member = root.dataset.member === 'true';
    const audioEnabled = root.dataset.audioEnabled === 'true';
    const audioPath = root.dataset.audioPath || '';
    const pageSize = Math.max(25, Number.parseInt(root.dataset.pageSize || '50', 10));
    const list = root.querySelector('[data-fan-list]');
    const search = root.querySelector('[data-fan-search]');
    const count = root.querySelector('[data-fan-count]');
    const empty = root.querySelector('[data-fan-empty]');
    const previous = root.querySelector('[data-fan-previous]');
    const next = root.querySelector('[data-fan-next]');
    const pageStatus = root.querySelector('[data-fan-page-status]');
    const liveStatus = root.querySelector('[data-fan-live-status]');
    if (!list || !search || !count || !previous || !next || !pageStatus) return;
    let page = 1;
    let query = '';
    let currentAudio = null;
    let currentButton = null;
    let debounceTimer = null;
    const stopAudio = () => {
      if (currentAudio) { currentAudio.pause(); currentAudio.currentTime = 0; }
      if (currentButton) { currentButton.setAttribute('aria-busy', 'false'); currentButton.removeAttribute('aria-pressed'); }
      currentAudio = null;
      currentButton = null;
    };
    const audioUrl = (reference) => /^https:\/\//i.test(reference) ? reference : `${audioPath}${encodeURIComponent(reference)}`;
    const play = async (word, reference, button, position) => {
      stopAudio();
      currentButton = button;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-pressed', 'true');
      currentAudio = new Audio(audioUrl(reference));
      currentAudio.preload = 'none';
      currentAudio.addEventListener('playing', () => {
        button.setAttribute('aria-busy', 'false');
        if (liveStatus) liveStatus.textContent = `Playing ${word}`;
        track('antonym_pronunciation_played', { position, word, member });
      }, { once: true });
      currentAudio.addEventListener('ended', stopAudio, { once: true });
      currentAudio.addEventListener('error', () => {
        stopAudio();
        if (liveStatus) liveStatus.textContent = `Pronunciation for ${word} is temporarily unavailable.`;
      }, { once: true });
      try { await currentAudio.play(); }
      catch (_error) {
        stopAudio();
        if (liveStatus) liveStatus.textContent = `Pronunciation for ${word} could not be played.`;
      }
    };
    const makeButton = (word, reference, position) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fba__audio button button--secondary';
      button.setAttribute('aria-label', `Listen to the pronunciation of ${word}`);
      button.setAttribute('aria-busy', 'false');
      button.title = `Listen to ${word}`;
      button.disabled = !audioEnabled || !reference || (!audioPath && !/^https:\/\//i.test(reference));
      const symbol = document.createElement('span');
      symbol.className = 'fba__audio-symbol';
      symbol.setAttribute('aria-hidden', 'true');
      symbol.textContent = '▶';
      button.append(symbol);
      if (!button.disabled) button.addEventListener('click', () => play(word, reference, button, position));
      return button;
    };
    const makeRow = (item) => {
      const row = document.createElement('li');
      row.className = 'fba__row fan__row';
      const position = document.createElement('span');
      position.className = 'fba__position';
      position.textContent = String(item.position).padStart(4, '0');
      const words = document.createElement('strong');
      words.className = 'fba__french';
      words.lang = 'fr';
      words.textContent = `${item.french} ↔ ${item.antonym}`;
      const meaning = document.createElement('span');
      meaning.className = 'fba__translation';
      meaning.textContent = `${item.english} ↔ ${item.antonymEnglish}`;
      const type = document.createElement('small');
      type.className = 'fba__level';
      type.textContent = item.category;
      meaning.append(type);
      const audio = document.createElement('span');
      audio.className = 'fan__audio-group';
      audio.append(makeButton(item.french, item.headAudio, item.position));
      if (item.antonymAudio) audio.append(makeButton(item.antonym, item.antonymAudio, item.position));
      row.append(position, words, meaning, audio);
      return row;
    };
    const render = () => {
      stopAudio();
      const filtered = query ? data.filter((item) => normalize(`${item.french} ${item.antonym} ${item.english} ${item.antonymEnglish} ${item.category}`).includes(query)) : data;
      const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
      page = Math.min(page, pages);
      const start = (page - 1) * pageSize;
      const visible = filtered.slice(start, start + pageSize);
      list.replaceChildren(...visible.map(makeRow));
      empty.hidden = filtered.length !== 0;
      count.textContent = filtered.length === data.length ? `${data.length} antonym pairs available` : `${filtered.length} matching pairs`;
      pageStatus.textContent = filtered.length ? `Showing ${start + 1}–${start + visible.length} of ${filtered.length}` : 'No results';
      previous.disabled = page <= 1;
      next.disabled = page >= pages;
    };
    search.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => {
        query = normalize(search.value.trim());
        page = 1;
        render();
        track('antonym_search', { has_query: Boolean(query), member });
      }, 150);
    });
    previous.addEventListener('click', () => { page -= 1; render(); root.querySelector('[data-fan-list-heading]')?.focus(); });
    next.addEventListener('click', () => { page += 1; render(); root.querySelector('[data-fan-list-heading]')?.focus(); });
    root.querySelector('[data-fan-membership-cta]')?.addEventListener('click', () => track('membership_cta_clicked', { module: 'antonyms' }));
    root.querySelector('[data-fan-sign-in]')?.addEventListener('click', () => track('sign_in_prompted', { module: 'antonyms' }));
    render();
    track('antonym_page_view', { member, available_pairs: data.length });
    if (!member) track('antonym_paywall_viewed', { locked_pairs: 900 });
  };
  document.querySelectorAll('[data-fan-root]').forEach(initialize);
})();
